// extracted by mini-css-extract-plugin
export default {"Communities":"Communities_Communities__AZ5Xg","communityCard":"Communities_communityCard__yZGir","gridContainer":"Communities_gridContainer__Ho-Pu"};